import request from '@host-panel/request';

type Response = {
  timeline: MessageAuditEvent[];
  users: Record<string, User>;
};

type RequestPayload = {
  messageId: string;
  offset?: number;
  limit?: number;
  isOnlyManual?: boolean;
};

interface MessageAuditEvent {
  user_id: string;
  current_state: string;
  previous_state: string;
  action: string;
  published: boolean;
  timestamp: number;
}

interface User {
  blacklisted: boolean;
  display_name: string;
  id: string;
  image_id: string;
  online: boolean;
  registered: boolean;
  user_name: string;
  roles: string[];
}

export default function messageAuditLog({
  messageId,
  offset = 0,
  limit = 40,
  isOnlyManual = false
}: RequestPayload): Promise<Response> {
  return request(`/host-panel/audit/${messageId}`, {
    method: 'GET',
    data: {
      offset,
      limit,
      manual: isOnlyManual
    }
  });
}
